export const AUTH_UPDATE_STATE = "AUTH_UPDATE_STATE";
export const UPDATE_PURCHASED = "UPDATE_PURCHASED";
export const SET_SETTINGS_MODAL = "SET_SETTINGS_MODAL";
export const SET_PASSWORD_RESET_MODAL = "SET_PASSWORD_RESET_MODAL";
export const SET_CURRENT_CATEGORY = "SET_CURRENT_CATEGORY";
export const SET_MAILCHIMP_TAGS = "SET_MAILCHIMP_TAGS";
export const SET_INCLUDE_NSFW = "SET_INCLUDE_NSFW";
